module.exports = __webpack_public_path__ + "img/icon-manufacturing.5a8ea5aa.svg";